/**
 * The purpose of `ComponentRegistry` is to store references to components with a global id so they can be accessed from any code in the application,
 * this allows us to delegate certain event listeners to higher levels and then call the components handler methods instead of attaching listeners to each component.
 */
export class ComponentRegistry {
    constructor() {
        this.registry = new Map();
    }
    registerComponent(id, component) {
        this.registry.set(id, component);
    }
    unregisterComponent(id) {
        this.registry.delete(id);
    }
    getComponent(id) {
        return this.registry.get(id);
    }
    forEach(callback) {
        this.registry.forEach(callback);
    }
    getComponentByElement(element, traverseDOM = true) {
        let id = element.getAttribute('data-global-id');
        if (!id && traverseDOM) {
            // Traverse upwards to find the closest parent with a data-global-id attribute
            while (element && !element.getAttribute('data-global-id')) {
                element = element.parentElement;
            }
            // If a component root element is found
            if (element && element.getAttribute('data-global-id')) {
                id = element.getAttribute('data-global-id');
            }
        }
        if (!id) {
            return;
        }
        return this.registry.get(id);
    }
    getFormComponentByElement(element) {
        // Traverse upwards from the element
        while (element) {
            // Check if the current element is the desired form
            if (element.classList.contains('s360Form') && element.hasAttribute('data-global-id')) {
                const formsId = element.getAttribute('data-global-id'); // Get the global-id
                return this.getComponent(formsId); // Call getComponent with the global-id
            }
            element = element.parentElement; // Move to the parent element
        }
        return undefined; // Return undefined if no form is found
    }
    getScreenComponentByElement(element) {
        // Traverse upwards from the element
        while (element) {
            // Check if the current element is the desired form
            if (element.classList.contains('s360Screen') && element.hasAttribute('data-global-id')) {
                const screenId = element.getAttribute('data-global-id'); // Get the global-id
                return this.getComponent(screenId); // Call getComponent with the global-id
            }
            element = element.parentElement; // Move to the parent element
        }
        return undefined; // Return undefined if no form is found
    }
}
